import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, ShieldCheck, Clock, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Finalbookingcta() {
  return <section data-section-id="252547" id="finalbookingcta" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-foreground px-6 py-16 sm:px-12 sm:py-20 md:px-16 lg:py-24 text-center shadow-2xl">
          {}
          <div className="absolute -top-32 -left-32 h-96 w-96 rounded-lg bg-primary/10 blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-lg bg-primary/10 blur-3xl pointer-events-none"></div>
          
          <div className="relative z-10 mx-auto max-w-3xl flex flex-col items-center">
            <h2 className="font-default text-3xl font-bold tracking-tight text-background sm:text-4xl md:text-5xl mb-6">Få offert på badrumsrenovering i Karlstad</h2>
            
            <p className="font-sans text-lg text-background/90 mb-10 max-w-2xl">När du vill få en offert på badrum i Karlstad börjar vi med ett kostnadsfritt hembesök. Vi går igenom badrummets förutsättningar, dina önskemål, materialval och projektets omfattning. Därefter tar vi fram en tydlig och specificerad offert för din badrumsrenovering.</p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 w-full">
              <Link to="/QuoteRequestPage" className="w-full sm:w-auto">
                <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-lg font-bold rounded-md bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-transform hover:scale-105">
                  <SafeHydrate><Calendar className="mr-2 h-6 w-6" /></SafeHydrate>
                  Boka mitt hembesök nu
                </Button>
              </Link>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-background/20 w-full max-w-2xl">
              <div className="flex flex-col items-center gap-2 text-background/90">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-background/10">
                  <Clock className="h-6 w-6 text-primary" />
                </div>
                <span className="font-sans text-sm font-medium">Snabb respons</span>
              </div>
              <div className="flex flex-col items-center gap-2 text-background/90">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-background/10">
                  <ShieldCheck className="h-6 w-6 text-primary" />
                </div>
                <span className="font-sans text-sm font-medium">Certifierat våtrum</span>
              </div>
              <div className="flex flex-col items-center gap-2 text-background/90">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-background/10">
                  <Wrench className="h-6 w-6 text-primary" />
                </div>
                <span className="font-sans text-sm font-medium">Totalentreprenad</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}